export default [
    {
        name: 'queryCouponLists',
        url: '/lists'
    },
    {
        name: 'addCoupon',
        url: '/add'
    },
    {
        name: 'serialLists',
        url: '/serialLists'
    },
    {
        name: 'serialDelete',
        url: '/serialDelete'
    }
];
